
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/actualites/[slug]",
      function () {
        return require("private-next-pages/actualites/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/actualites/[slug]"])
      });
    }
  